import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserLocalPersistence,
  User
} from 'firebase/auth';
import { app } from './firebase-config';
import { trackLogin, trackLogout } from './analytics';

export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence);

export interface AuthState {
  user: User | null;
  loading: boolean;
}

export const signIn = async (email: string, password: string) => {
  const result = await signInWithEmailAndPassword(auth, email, password);
  trackLogin();
  return result;
};

export const logout = async () => {
  await signOut(auth);
  trackLogout();
};

export const onAuthChange = (callback: (user: User | null) => void) =>
  onAuthStateChanged(auth, callback);
